<template>
  <div id="app">
    <router-view />

    <!-- 首次登录 / 强制修改密码（全局遮罩，无法关闭） -->
    <el-dialog
      title="首次登录，请修改密码"
      :visible.sync="forceChangePasswordVisible"
      width="440px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      append-to-body
      custom-class="force-change-pwd-dialog"
      @opened="handlePwdDialogOpened"
    >
      <div class="pwd-tip">
        <i class="el-icon-warning-outline" />
        <span>为了账户安全，首次登录必须先修改初始密码；<br/>修改后需要重新登录。</span>
      </div>
      <el-form
        ref="forcePwdForm"
        :model="pwdForm"
        :rules="pwdRules"
        label-width="96px"
      >
        <el-form-item label="初始密码" prop="oldPassword">
          <el-input v-model="pwdForm.oldPassword" type="password" show-password placeholder="请输入当前初始密码" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" show-password placeholder="6-20 位，请勿与初始密码相同" />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="pwdForm.confirmPassword" type="password" show-password placeholder="请再次输入新密码" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button :loading="submitting" type="primary" @click="handleSubmitPwd">提交修改并重新登录</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const validateConfirm = function(rule, value, callback) {
  if (!value) {
    callback(new Error('请再次输入新密码'))
  } else if (value !== this.pwdForm.newPassword) {
    callback(new Error('两次输入的新密码不一致'))
  } else {
    callback()
  }
}

const validateDiffOld = function(rule, value, callback) {
  if (value && value === this.pwdForm.oldPassword) {
    callback(new Error('新密码不能与初始密码相同'))
  } else {
    callback()
  }
}

export default {
  name: 'App',
  data() {
    return {
      submitting: false,
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      pwdRules: {
        oldPassword: [
          { required: true, message: '请输入当前初始密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度应在 6-20 位之间', trigger: 'blur' },
          { validator: validateDiffOld.bind(this), trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirm.bind(this), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('user', ['forceChangePasswordVisible', 'userInfo'])
  },
  methods: {
    handlePwdDialogOpened() {
      if (this.$refs.forcePwdForm) this.$refs.forcePwdForm.resetFields()
      this.submitting = false
      // 兜底：如果 storage 没带 mustChangePassword，再让后端确认一次
      if (this.userInfo && this.userInfo.mustChangePassword === true) {
        // do nothing
      } else {
        this.$store.dispatch('user/getInfo').catch(() => {})
      }
    },
    handleSubmitPwd() {
      this.$refs.forcePwdForm.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          await this.$store.dispatch('user/forceChangePassword', {
            oldPassword: this.pwdForm.oldPassword,
            newPassword: this.pwdForm.newPassword
          })
          this.$message.success('密码修改成功，请使用新密码重新登录')
          // 强制改密成功后，退出登录，保证登录流程走一遍，避免改完留在页面仍持旧 token
          await this.$store.dispatch('user/logout')
          this.$router.push('/login')
        } catch (err) {
          this.$message.error((err && err.message) || '密码修改失败')
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  background: #f0f2f5; /* 与管理端/员工端内容区底色一致，避免挂载前白底闪烁 */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  overscroll-behavior-y: none;
}
#app {
  height: 100%;
  min-height: 100vh;
  min-height: -webkit-fill-available;
}
/* 防止手机软键盘弹出后整体挤压出现横向滚动条 */
@media (max-width: 480px) {
  html, body, #app {
    overflow-x: hidden;
  }
}
.pwd-tip {
  display: flex;
  align-items: flex-start;
  padding: 10px 14px;
  margin: 0 0 16px;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  color: #e6a23c;
  border-radius: 4px;
  line-height: 1.6;
  font-size: 13px;
}
.pwd-tip > i {
  margin-right: 8px;
  font-size: 16px;
  line-height: 1.6;
}
.force-change-pwd-dialog .el-dialog__header {
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  border-radius: 6px 6px 0 0;
  padding-top: 18px;
  padding-bottom: 18px;
}
.force-change-pwd-dialog .el-dialog__title {
  color: #303133;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.force-change-pwd-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #909399;
}
</style>
